// extracted by mini-css-extract-plugin
module.exports = {"deleteItem":"XBF4Pwh"};